import React, { Component } from 'react';
import Page from '../../../components/Page';
import { Icon, Breadcrumb, Button, Modal, Header, Segment, List, Form, Container, Grid, GridColumn, Table, Checkbox, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { post } from '../../../util/api';
import MyMenu from '../menu';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

class Phones extends Component {
	phoneToDelete = null;
	state = {
		loading: true,
		saveButton: 'add',
		newWaList: [],
	};
	async componentDidMount() {
		await this.getBusinessPhoneList();
		await this.getBusinessTemplates();
		await this.getList();
	}
	async getList() {
		let list = await post('/dahi/message/getLiveChat', {});
		let wa_templates = (list.data.result && list.data.result.staticOptions && list.data.result.staticOptions.wa_templates) || [];
		let waba_gen_id = (list.data.result && list.data.result.staticOptions && list.data.result.staticOptions.waba_gen_id) || '';
		this.setState({ waba_gen_id, wa_templates, loading: false }, () => this.syncSelected());
	}
	// seçili numaranın WABA'sına ait kayıtlı şablonlar; eski (etiketsiz) kayıtlar namespace ile eşlenir
	belongsToCurrent(it) {
		let { template_config, templates } = this.state;
		let cur = template_config && template_config.waba_gen_id;
		if (it.waba_gen_id) return String(it.waba_gen_id) === String(cur);
		return !!it.namespace && _.some(templates, (t) => t.namespace === it.namespace);
	}
	syncSelected() {
		let { wa_templates } = this.state;
		let newWaList = _.filter(wa_templates, (it) => this.belongsToCurrent(it));
		this.setState({ newWaList });
	}
	changePhone(value) {
		this.setState({ selectedBusinessphone: value, templateLoading: true }, async () => {
			await this.getBusinessTemplates();
			this.syncSelected();
		});
	}
	async getBusinessPhoneList() {
		let { product } = this.props;
		let pid = product.id;
		await post('/broadcast/phoneList', { pid }).then((data) => {
			let phones = data.data.phones;
			let businessPhoneList = [];
			if (phones && phones.length) {
				businessPhoneList = _.map(phones, (it) => ({
					value: it,
					text: it,
				}));
			}
			this.setState({ businessPhoneList, selectedBusinessphone: businessPhoneList && businessPhoneList[0] && businessPhoneList[0].value });
		});
	}
	async getBusinessTemplates(refresh = false) {
		let { selectedBusinessphone } = this.state;
		let { product } = this.props;
		let pid = product.id;
		await post('/broadcast/templateList ', { pid, shop: selectedBusinessphone, refresh }).then((data) => {
			//console.log('da', data);
			let templates = _.filter(data.data.templates, (it) => it.status === 'APPROVED' || it.status === 'approved');
			let template_config = data.data.config;
			let template_list = _.map(templates, (it) => ({
				text: it.name,
				value: it.name,
				includeVariable: _.findIndex(it.components, (o) => /{{\d+}}/.test(o.text)),
			}));
			template_list = _.filter(template_list, (it) => it.includeVariable < 0);
			this.setState({ templates, template_list, template_config, templateLoading: false });
		});
	}
	handleChange = (e, { name, value }) => {
		let { selected, tag_list } = this.state;
		tag_list[selected][name] = value;
		this.setState({ tag_list });
	};
	colorChance(value) {
		let { selected, tag_list } = this.state;
		tag_list[selected].color = value;
		this.setState({ tag_list });
	}
	addTagList() {
		let { tag_list } = this.state;
		if (!tag_list.length || tag_list[tag_list.length - 1]._id)
			tag_list.push({
				title: '',
				color: '#5d9cec',
			});
		this.setState({ tag_list, selected: tag_list.length - 1, saveButton: 'add' });
	}
	async saveTemplate() {
		let { newWaList, wa_templates, template_config, selectedBusinessphone } = this.state;
		let waba_gen_id = template_config && template_config.waba_gen_id;
		this.setState({ saveButtonLoading: true });
		// diğer WABA'ların şablonları korunur, sadece seçili WABA'nınkiler değişir
		let others = _.filter(wa_templates, (it) => !this.belongsToCurrent(it));
		let current = _.map(newWaList, (it) => ({
			..._.pick(it, ['name', 'status', 'language', 'namespace', 'components', 'label']),
			waba_gen_id,
			shop: selectedBusinessphone,
		}));
		await post('/dahi/message/updateWaTemplates', { list: others.concat(current) });
		await this.getList();
		this.setState({ saveButtonLoading: false });
	}
	handleSelectedList(obj) {
		let { newWaList } = this.state;
		let key = { name: obj.name, language: obj.language };
		if (_.find(newWaList, key)) newWaList = _.reject(newWaList, key);
		else newWaList = newWaList.concat(obj);
		this.setState({ newWaList });
	}
	render() {
		const { t } = this.props;
		let {
			tag_list,
			selected,
			saveButton,
			saveButtonLoading,
			deleteButtonLoading,
			wa_templates,
			templates,
			templateLoading,
			newWaList,
			waba_gen_id,
			businessPhoneList,
			selectedBusinessphone,
		} = this.state;
		if (this.state.loading) {
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
						</Breadcrumb>
					}
					flex
				>
					<MyMenu activeItem="wabatemplates">
						<Page.Loader />
					</MyMenu>
				</Page>
			);
		} else if (!waba_gen_id && !(businessPhoneList && businessPhoneList.length)) {
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />
							<Breadcrumb.Section>WABA Template</Breadcrumb.Section>
						</Breadcrumb>
					}
					flex
				>
					<MyMenu activeItem="wabatemplates">
						<Page.Wrap>
							<Segment>{t('contactUsWabaTemplate')}</Segment>
						</Page.Wrap>
					</MyMenu>
				</Page>
			);
		} else {
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />
							<Breadcrumb.Section>WABA Template</Breadcrumb.Section>
						</Breadcrumb>
					}
					flex
				>
					<MyMenu activeItem="wabatemplates">
						<Page.Wrap>
							<Grid>
								<GridColumn width={6}>
									<Segment>
										<Header>Live Chat</Header>

										<Table>
											<Table.Body>
												{_.map(wa_templates, (it) => (
													<Table.Row>
														<Table.Cell>
															{it.name} - {it.language}
														</Table.Cell>
														<Table.Cell collapsing>{it.shop || ''}</Table.Cell>
													</Table.Row>
												))}
											</Table.Body>
										</Table>
									</Segment>
								</GridColumn>
								<GridColumn width={10}>
									<Segment>
										<div style={{ display: 'flex' }}>
											<Header style={{ margin: 0 }}>System</Header>
											{businessPhoneList && businessPhoneList.length > 1 && (
												<Dropdown
													selection
													options={businessPhoneList}
													value={selectedBusinessphone}
													onChange={(e, { value }) => this.changePhone(value)}
													style={{ marginLeft: 10 }}
												/>
											)}
											<Button
												basic
												color="green"
												type="button"
												loading={templateLoading}
												style={{ marginLeft: 'auto' }}
												onClick={() => {
													this.setState({ templateLoading: true });
													this.getBusinessTemplates(true);
												}}
											>
												Yenile
											</Button>
											<Button
												color="blue"
												type="button"
												loading={templateLoading || saveButtonLoading}
												onClick={() => {
													//this.setState({ templateLoading: true });
													this.saveTemplate(true);
												}}
											>
												Yeni Listeyi Kaydet
											</Button>
										</div>
										<Table>
											<Table.Body>
												{_.map(templates, (it) => (
													<Table.Row>
														<Table.Cell width={1}>
															<Checkbox
																checked={!!_.find(newWaList, { name: it.name, language: it.language })}
																onChange={() => this.handleSelectedList(it)}
															></Checkbox>
														</Table.Cell>
														<Table.Cell>
															{it.name} - {it.language}
														</Table.Cell>
													</Table.Row>
												))}
											</Table.Body>
										</Table>
									</Segment>
								</GridColumn>
							</Grid>
						</Page.Wrap>
					</MyMenu>
				</Page>
			);
		}
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(Phones));
